<template>
  <div>
    <v-navigation-drawer v-model="filterDrawerOpen"
                         class="primary"
                         width="300"
                         right
                         clipped
                         app
                         style="overflow-y:hidden; bottom: 0">
      <v-card height="100%" class="px-2 pt-2">
        <div class="ml-4 mr-3">
          <slot name="filters" />
        </div>
      </v-card>
    </v-navigation-drawer>

    <tooltip bottom>
      <v-slide-x-reverse-transition slot="activator">
        <v-btn v-show="!filterDrawerOpen"
               fab
               app
               bottom
               fixed
               dark
               small
               color="blue darken-2"
               style="right: 10px; top: 180px; z-index: 6"
               @click="filterDrawerOpen = true">
          <nt-icon>menu_open</nt-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <span>Open Search Filters</span>
    </tooltip>

    <tooltip bottom>
      <v-slide-x-reverse-transition slot="activator">
        <v-btn v-show="filterDrawerOpen"
               fab
               app
               bottom
               small
               fixed
               dark
               color="blue darken-2"
               style="right: 277px; top: 180px; z-index: 6"
               @click="filterDrawerOpen = false">
          <nt-icon>arrow_forward_ios</nt-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <span>Close Search Filters</span>
    </tooltip>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        filterDrawerOpen: true
      }
    }
  }
</script>
